import _ from "lodash";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

import { Button } from "@/component-library";
import { createClassNameString } from "@/component-library";
import images from "@/utils/images";
import { updateSelectedDate, toggleDatePicker } from "@/redux/actions/calendar";

import "./styles.scss";

const ScheduleNavControls = ({ className, selectedDay: _selectedDay, ...props }) => {
  const getToday = () => {
    const selectedDate = moment();

    props.updateSelectedDate(selectedDate);
  };

  /**
   * gets the previous day or week depending on the calendars view type
   */
  const getPrev = () => {
    const clonedSelectedDay = _.cloneDeep(props.calendar.selectedScheduleDate);

    clonedSelectedDay.subtract(props.calendar.viewType === "WEEK" ? 7 : 1, "day");
    props.updateSelectedDate(clonedSelectedDay);
  };

  /**
   * gets the next day or week depending on the calendars view type
   */
  const getNext = () => {
    const clonedSelectedDay = _.cloneDeep(props.calendar.selectedScheduleDate);

    clonedSelectedDay.add(props.calendar.viewType === "WEEK" ? 7 : 1, "day");
    props.updateSelectedDate(clonedSelectedDay);
  };

  return (
    <div className={createClassNameString(["apti-CL apti-ScheduleNavControls", className])}>
      <div className={createClassNameString(["apti-ScheduleNavControls--controls"])}>
        <Button
          buttonType="primary-outline"
          className={createClassNameString(["apti-ScheduleNavControls--controls-today mr-3"])}
          onClick={getToday}
        >
          Today
        </Button>

        <button
          className={createClassNameString(["apti-ScheduleNavControls--controls-group-item"])}
          onClick={getPrev}
        >
          <img
            alt="previous"
            className="apti-ScheduleNavControls--icon"
            src={images("./icons/Chevron_Left.svg")}
          />
        </button>

        <button
          className={createClassNameString(["apti-ScheduleNavControls--controls-group-item"])}
          onClick={getNext}
        >
          <img
            alt="next"
            className="apti-ScheduleNavControls--icon"
            src={images("./icons/Chevron_Right.svg")}
          />
        </button>

        <button
          className={createClassNameString(["apti-ScheduleNavControls--controls-group-item"])}
          onClick={props.toggleDatePicker}
        >
          <img
            alt="calender"
            className={createClassNameString([
              "apti-ScheduleNavControls--controls-group-item-calendar apti-ScheduleNavControls--icon",
            ])}
            src={images("./icons/calendar_outline.svg")}
          />
        </button>
      </div>
    </div>
  );
};

ScheduleNavControls.propTypes = {
  className: PropTypes.string,
  selectedDay: PropTypes.instanceOf(moment),
};

ScheduleNavControls.defaultProps = {
  className: undefined,
  selectedDay: moment(),
};

const mapStateToProps = (state) => {
  return {
    calendar: state.calendar,
  };
};

const mapDispatchToProps = {
  updateSelectedDate,
  toggleDatePicker,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleNavControls);
